import axios from "axios";
import config from "@/vue.config";

export default class Api {
  constructor(accessToken) {
    this.client = Api.makeClient(config.printers.host, accessToken);
  }

  static makeClient(printerHost, accessToken) {
    const options = {
      baseURL: printerHost,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer: ${accessToken}`,
      },
    };
    return axios.create(options);
  }
}



// WEBPACK FOOTER //
// ./src/api.js